import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { resetScrollPosition } from "utilities/resetScrollPosition";

/** Scrolls to top when the route pathname changes (default SPA behavior). */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    resetScrollPosition();
  }, [pathname]);

  return null;
}
